module.exports = __webpack_public_path__ + "media/images/lb/385-e45bd90188d5bf7ae6401cfcd29766db.svg";